(function () {
  "use strict";

  SeriesEmailsCtrl.$inject = ['$scope', '$routeParams', 'CustomEmailResource', '$rootScope', '$location', 'Validation', 'textLengthIndicatorState', 'CustomizeResource', 'mtypes', '$sce'];
  angular
    .module('trainerWebApp.controllers')
    .controller('SeriesEmailsCtrl', SeriesEmailsCtrl);

  function SeriesEmailsCtrl($scope, $routeParams, CustomEmailResource, $rootScope, $location, Validation,
                            textLengthIndicatorState, CustomizeResource, mtypes, $sce) {

    $scope.seriesId = $routeParams.seriesId;

    var acc = ['0', '1', '2'].indexOf($routeParams.acc) == -1 ? 0 : $routeParams.acc;
    var maxCustomTextLength = 1000;

    $scope.modal = {
      content: "Loading"
    };

    var resolvedData = $scope.resolvedData;

    // If server sends back none mtype then use default of 3 days to start.
    if (resolvedData.reminderSettings.reminderInterval == mtypes.reminderInterval.none)
      resolvedData.reminderSettings.reminderInterval = mtypes.reminderInterval.threeDays;

    $scope.reminderSettings = {
      reminderActive: resolvedData.reminderSettings.reminderActive == 1,
      reminderInterval: resolvedData.reminderSettings.reminderInterval
    };

    $scope.resolvedData = null;

    $scope.panes = [
      {
        name: 'Invitation',
        text: $sce.trustAsHtml(resolvedData.invitation.text),
        customText: $('<div/>').html(resolvedData.invitation.customText).text(),
        showInfo: false,
        open: true
      },
      {
        name: 'Reminder',
        text: $sce.trustAsHtml(resolvedData.reminder.text),
        customText: $('<div/>').html(resolvedData.reminder.customText).text(),
        showInfo: true,
        open: false
      },
      {
        name: 'Completion',
        text: $sce.trustAsHtml(resolvedData.completion.text),
        customText: $('<div/>').html(resolvedData.completion.customText).text(),
        showInfo: false,
        open: false
      }
    ];

    _.each($scope.panes, function (pane) {
      pane.disableAction = true;
      pane.reminderSettingsChanged = false;
      pane.customTextChanged = false;
      pane.title = pane.name + ' Email';
      resolvedData[pane.name.toLowerCase()].customText = pane.customText;
    });

    var timer = setTimeout(function () {
      angular.element('#collapse' + acc).addClass('in');
    }, 1);

    $scope.saveData = function (pane) {
      saveCustomEmail(pane);
      saveReminderSettings(pane);
    };

    function saveCustomEmail(pane) {
      if (!pane.customTextChanged)
        return;
      pane.customTextChanged = false;
      CustomEmailResource['update' + pane.name]($scope.seriesId, pane.customText, function (result) {
        resolvedData[pane.name.toLowerCase()].customText = pane.customText;
        pane.disableAction = true;
        seriesDescriptionChange(pane, '');
      }, function (error) {
        pane.disableAction = true;
      });
    }

    function saveReminderSettings(pane) {
      if (!pane.reminderSettingsChanged)
        return;
      pane.reminderSettingsChanged = false;
      CustomizeResource.updateCourseReminderSettings($scope.seriesId, $scope.reminderSettings.reminderActive, $scope.reminderSettings.reminderInterval, function (result) {
        pane.disableAction = true;
        resolvedData.reminderSettings.reminderActive = $scope.reminderSettings.reminderActive;
        resolvedData.reminderSettings.reminderInterval = $scope.reminderSettings.reminderInterval;
      }, function (error) {
        pane.disableAction = true;
      });
    }

    $scope.resetCustomEmail = function (pane) {
      pane.customText = resolvedData[pane.name.toLowerCase()].customText;
      pane.disableAction = true;
      pane.reminderSettingsChanged = false;
      pane.customTextChanged = false;
      resetReminderSettings(pane);
      seriesDescriptionChange(pane, pane.customText);
    };

    $scope.taChange = function (pane) {
      pane.customTextChanged = true;
      pane.disableAction = false;
      seriesDescriptionChange(pane, pane.customText);
    };

    function seriesDescriptionChange(pane, customText) {
      var state = textLengthIndicatorState.getState(customText, maxCustomTextLength);
      pane.seriesDescriptionIndicatorStyle = state.style;
      pane.seriesDescriptionIndicatorText = state.text;
      pane.formValid = state.lengthValid;
    }

    function resetReminderSettings(pane) {
      if (pane.name != 'Reminder')
        return;

      $scope.reminderSettings = {
        reminderActive: resolvedData.reminderSettings.reminderActive == 1,
        reminderInterval: resolvedData.reminderSettings.reminderInterval
      };
    }

    $scope.previewEmail = function (pane) {
      CustomEmailResource['preview' + pane.name]($scope.seriesId, pane.customText).$promise.then(function (result) {
        $scope.modal.content = {};
        $scope.modal.content.text = $sce.trustAsHtml(result.text);
      });
    };

    $scope.reminderSettingsChange = function (pane) {
      if (pane.name != 'Reminder') return;
      pane.disableAction = false;
      pane.reminderSettingsChanged = true;
      seriesDescriptionChange(pane, pane.customText);
    };

    $scope.reminderIntervals = [
      {
        text: '3 days',
        mtype: mtypes.reminderInterval.threeDays
      },
      {
        text: '7 days',
        mtype: mtypes.reminderInterval.oneWeek
      },
      {
        text: '14 days',
        mtype: mtypes.reminderInterval.twoWeeks
      }
    ];

    // Validation
    Validation.addValidation(validate);

    var nextLocation;
    var continueNavigation = false;

    function validate() {
      var retVal = [];
      angular.forEach($scope.panes, function (pane) {
        if (pane.customText != resolvedData[pane.name.toLowerCase()].customText)
          this.push(pane);
      }, retVal);

      if (_.isEmpty(retVal)) {
        Validation.removeValidation(validate);
        return true;
      }

      nextLocation = $rootScope.newLocation.next;
      angular.element("#save-email-modal").modal("show");
      return false;
    }

    angular.element("#save-email-modal").on('hidden', function () {
      if (!continueNavigation)
        return;
      Validation.removeValidation(validate);
      $location.path(nextLocation.path).search(nextLocation.search);
      $rootScope.$apply();
    });

    $scope.continueNavigation = function () {
      console.log('continue true');
      continueNavigation = true;
    };

    $scope.$on('$destroy', function () {
      Validation.removeValidation(validate);
      clearTimeout(timer);
      $scope.modal = null;
      angular.element("#save-email-modal").off();
    });

    $scope.getArrowClass = function (pane) {
      return pane.open ? "accordion-section-indicator accordion-section-indicator-desc" : "accordion-section-indicator accordion-section-indicator-asc";
    }
  }

})();
